module.exports = __webpack_public_path__ + "img/support.02525e15.svg";